import { takeLatest, all } from 'redux-saga/effects'
import api from '../Services/Api'
/* ------------- Types ------------- */
import { MasterCacheTypes } from '../Redux/MasterCacheRedux'
import { CouponTypes } from '../Redux/CouponRedux'
import { ResetPasswordTypes } from '../Redux/ResetPasswordRedux'
import { BookTypes } from '../Redux/BookRedux'
import { ShopifyTypes } from '../Redux/ShopifyRedux'
import { CmsModelListTypes } from '../Redux/CmsModelListRedux'
import { CmsModelDeleteTypes } from '../Redux/CmsModelDeleteRedux'
import { CmsModelAddTypes } from '../Redux/CmsModelAddRedux'
import { CmsModelUpdateTypes } from '../Redux/CmsModelUpdateRedux'
import { UserListTypes } from '../Redux/UserListRedux'
import { UploadTypes } from '../Redux/UploadRedux'
import { ProfileTypes } from '../Redux/ProfileRedux'
import { ForgotPasswordTypes } from '../Redux/ForgotPasswordRedux'
import { UserTypes } from '../Redux/UserRedux'
import { StartupTypes } from '../Redux/StartupRedux'
import { LoginTypes } from '../Redux/LoginRedux'
// import { RegisterTypes } from '../Redux/RegisterRedux'
/* ------------- Sagas ------------- */
import { masterCache } from './MasterCacheSaga'
import { couponList } from './CouponSaga'
import { resetPassword } from './ResetPasswordSaga'
import { book, getBookPreview } from './BookSaga'
import { shopifyAddProduct, shopifyCreateToken } from './ShopifySaga'
import { cmsModelList } from './CmsModelListSaga'
import { cmsModelDelete } from './CmsModelDeleteSaga'
import { cmsModelAdd } from './CmsModelAddSaga'
import { cmsModelUpdate } from './CmsModelUpdateSaga'
import { userList } from './UserListSaga'
import { upload } from './UploadSaga'
import { profileUpdateUsername, profileChangePassword } from './ProfileSaga'
import { forgotPassword } from './ForgotPasswordSaga'
import { user, userUpdate } from './UserSaga'
import { startup } from './StartupSagas'
import { login, logout } from './LoginSagas'
// import { register } from './RegisterSaga'
/* ------------- API ------------- */

// The API we use is only used from Sagas, so we create it here and pass along
// to the sagas which need it.

/* ------------- Connect Types To Sagas ------------- */

export default function * root () {
  yield all([
    // some sagas only receive an action
    takeLatest(StartupTypes.STARTUP, startup, api),
    // tool generated sagas
    takeLatest(BookTypes.BOOK_PREVIEW_REQUEST, getBookPreview, api.userBookPreview),
    takeLatest(MasterCacheTypes.MASTER_CACHE_REQUEST, masterCache, api.reloadMasterCache),
    takeLatest(CouponTypes.COUPON_LIST_REQUEST, couponList, api.couponList),
    takeLatest(ResetPasswordTypes.RESET_PASSWORD_REQUEST, resetPassword, api.resetPassword),
    takeLatest(BookTypes.BOOK_REQUEST, book, api.getBook),
    takeLatest(ShopifyTypes.SHOPIFY_ADD_PRODUCT_REQUEST, shopifyAddProduct, api.shopifyAddProduct),
    takeLatest(ShopifyTypes.SHOPIFY_CREATE_TOKEN_REQUEST, shopifyCreateToken, api.shopifyCreateToken),
    takeLatest(CmsModelListTypes.CMS_MODEL_LIST_REQUEST, cmsModelList, api.cmsModelList),
    takeLatest(CmsModelDeleteTypes.CMS_MODEL_DELETE_REQUEST, cmsModelDelete, api.cmsModelDelete),
    takeLatest(CmsModelAddTypes.CMS_MODEL_ADD_REQUEST, cmsModelAdd, api.cmsModelAdd),
    takeLatest(CmsModelUpdateTypes.CMS_MODEL_UPDATE_REQUEST, cmsModelUpdate, api.cmsModelUpdate),
    takeLatest(UserListTypes.USER_LIST_REQUEST, userList, api.userList),
    takeLatest(UploadTypes.UPLOAD_REQUEST, upload, api.upload),
    takeLatest(UserTypes.USER_UPDATE, userUpdate, api.userUpdate),
    takeLatest(UserTypes.USER_REQUEST, user, api.user),
    // Login
    takeLatest(LoginTypes.LOGIN_REQUEST, login, api.login),
    takeLatest(LoginTypes.LOGOUT_REQUEST, logout, api.logout),

    // Register
    // takeLatest(RegisterTypes.REGISTER_REQUEST, register, api.register),

    // Forgot Password
    takeLatest(ForgotPasswordTypes.FORGOT_PASSWORD_REQUEST, forgotPassword, api.forgotPassword),

    // Profile: update username
    takeLatest(ProfileTypes.PROFILE_UPDATE_USERNAME_REQUEST, profileUpdateUsername, api.updateUsername),

    // Profile: change password
    takeLatest(ProfileTypes.PROFILE_CHANGE_PASSWORD_REQUEST, profileChangePassword, api.changePassword)
  ])
}
